import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { RequestServiceService } from './helper/request-service.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CdkCustomMdlModule } from '@core/customCDK/cdkCustomMdl/cdk-custom-mdl.module';
import { ConfirmationModalOverlayRef } from '@core/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';
import { CONFIRMATION_MODAL_DATA } from '@core/customCDK/cdkCustomMdl/tokens/confirmation-data.token';
import { CategoryService } from '../category/helper/category.service';
import { SupportType } from '../helper/ticket.interface';
import { TicketingService } from '../helper/ticketing.service';

@Component({
  selector: 'app-ticketing-request',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CdkCustomMdlModule
  ],
  templateUrl: './ticketing-request.component.html',
  styleUrl: './ticketing-request.component.scss'
})
export class TicketingRequestComponent {
  form: FormGroup;
  typesData: SupportType;
  supportType: SupportType[];
  constructor(
    public dialogRef: ConfirmationModalOverlayRef,
    @Inject(CONFIRMATION_MODAL_DATA) public data: any,
    private fb: FormBuilder,
    private Router: Router,
    private _ticketService: RequestServiceService,
    private _CategoryService: CategoryService,
    private _TicketingService: TicketingService,

  ) {
    this._ticketService._supportType.subscribe((r: any) => {
      this.supportType = r?.data
    });
    this.form = this.fb.group({
      supportType: ['', Validators.required],
    });

  }

  close() {
    this.dialogRef.close();
  }

  supportTypeVaue(item: SupportType) {
    this.typesData = item;

  }

  category() {
    this._TicketingService.updateRaiseTicketData = {
      support_type_id: this.typesData.id
    };

    if (this.typesData.c_url.includes('raisecomplaint')) {
      this._CategoryService.fetchRequestType();
    } else {
      this.Router.navigate([this.typesData.c_url])
    }
    this.dialogRef.close();
  }

}
